import AuthPage from "../pages/AuthPage"
import MainPage from "../pages/MainPage"

export const RoutesList = {
    MAIN_ROUTER: '/',
    AUTH_ROUTER: '/login',
}

export const authRoutes = [
    {path: RoutesList.AUTH_ROUTER, component: AuthPage}
]

export const privateRoutes = [
    {path: RoutesList.MAIN_ROUTER, component: MainPage},
]